import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { showPopupNew } from '../../../actions/popup-actions';
import { PopupTypes } from '../../../utils/constants';
import { buildHotelPlannerUrl } from '../../../utils/url';
import useGlobalPrivilegesCta from '../../hooks/useGlobalPrivilegesCta';

import styles from './findAccommodations.scss';

const FindAccommodationsLegacy = ({ surface, event }) => {
    const dispatch = useDispatch();

    const hotelPlannerUrl = useMemo(() => buildHotelPlannerUrl(event), [event]);

    const onDismiss = () => {
        dispatch(showPopupNew({
            popup: PopupTypes.NOT_READY_FOR_POWER_POPUP,
            referringSurface: surface,
            redirectTo: hotelPlannerUrl,
        }));
    };

    const {
        user,
        handleCtaClick,
        handleLearnMoreClick,
        buttonText,
        findAccommodationsTitle,
        pastDueSubscriptionMessage,
    } = useGlobalPrivilegesCta({ surface, onDismiss });

    const hasPastDueSubscription = user?.hasPastDueSubscription;

    return (
        <div
            className={styles.findAccommodationsContainer}
            data-testid="event-profile.find-accommodations.legacy"
        >
            <p className={styles.title} data-testid="event-profile.find-accommodations.legacy.title">Need a Hotel?</p>
            <p className={styles.subtitle} data-testid="event-profile.find-accommodations.legacy.subtitle">{findAccommodationsTitle}</p>
            <ul className={styles.list} data-testid="event-profile.find-accommodations.legacy.benefits">
                <li>Over $250 of value in travel benefits</li>
                <li>Up to 60% off on 1.4 million hotels globally</li>
            </ul>
            {hasPastDueSubscription && (
                <p
                    className={styles.pastDueSubscriptionMessage}
                    data-testid="event-profile.find-accommodations.legacy.past-due-message"
                >
                    {pastDueSubscriptionMessage}
                </p>
            )}
            <button
                type="button"
                className={`btn btn-primary btn-small text-uppercase mt16 mb16 ${styles.button}`}
                onClick={handleCtaClick}
                data-testid="event-profile.find-accommodations.legacy.primary-cta"
            >
                {buttonText}
            </button>
            <div
                className={styles.learnMore}
                onClick={handleLearnMoreClick}
                data-testid="event-profile.find-accommodations.legacy.learn-more"
            >
                <span
                    className={styles.underline}
                    data-testid="event-profile.find-accommodations.legacy.learn-more-label"
                >
                    Learn more
                </span>
                {' about '}
                <span data-testid="event-profile.find-accommodations.legacy.learn-more-target">
                    Global Privileges
                </span>
            </div>
        </div>
    );
};

export default FindAccommodationsLegacy;
